module.exports = __webpack_public_path__ + "img/gb9117_4.prt.6d2bd8a1.jpg";